import { useCallback } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { message } from 'antd'
import { FileAddFilled, FilePdfOutlined } from '@ant-design/icons'
import { useDropzone } from 'react-dropzone'
import { createUseStyles } from 'react-jss'
import { dropZone as dropZoneStyles } from '../../theme/shared-styles'

const useStyles = createUseStyles(dropZoneStyles)

export default function AdditionalPdfDropzone({ onSelect }) {
  const classes = useStyles()

  const onDrop = useCallback(
    acceptedFiles => {
      const pdf = acceptedFiles.find(f => f.type === 'application/pdf')
      if (!pdf) {
        message.error('Please select a PDF file')
        return
      }
      onSelect(pdf)
    },
    [onSelect],
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { 'application/pdf': ['.pdf'] },
    multiple: false,
    useFsAccessApi: false,
    onDrop,
  })

  return (
    <div
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...getRootProps({
        className: classnames(
          classes.dropZone,
          isDragActive && classes.activeDropZone,
        ),
      })}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <input {...getInputProps()} />
      {isDragActive ? (
        <>
          <p>Drop the PDF here ...</p>
          <FileAddFilled />
        </>
      ) : (
        <>
          <p>Drag and drop a PDF here, or click to select the file</p>
          <FilePdfOutlined />
        </>
      )}
    </div>
  )
}

AdditionalPdfDropzone.propTypes = {
  onSelect: PropTypes.func.isRequired,
}
